var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKlmWorld(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "104.770062px",
    viewBox: "0 0 100 104.770062",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KLM",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "KLM/Loadingscreen",
    transform: "translate(-250.000000, -160.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(250.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#00A1DE",
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    rx: 50
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#007CAB",
    cx: 38,
    cy: 51,
    r: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1968002,44.347141 L88.1968002,44.347141 L88.1968002,89.8731611 L88.2033352,94.0484701 C84.0002407,95.3781378 79.8564025,96.1660739 75.7718206,96.4122786 C71.6872387,96.6584833 67.5085256,96.4185902 63.2356812,95.6925994 C57.6411104,94.3942954 53.4371335,93.0480944 50.6237503,91.6539964 C47.8103671,90.2598983 44.6767788,88.2056852 41.2229854,85.491357 L41.1968002,44.347141 Z",
    id: "Rectangle",
    fill: "#007CAB",
    transform: "translate(64.700068, 70.426473) rotate(-54.000000) translate(-64.700068, -70.426473) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icons/Small/Language",
    transform: "translate(10.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 56,
    height: 56
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28,3.5 C14.525,3.5 3.5,14.525 3.5,28 C3.5,41.475 14.525,52.5 28,52.5 C41.475,52.5 52.5,41.475 52.5,28 C52.5,14.525 41.475,3.5 28,3.5 Z M11.025,40.95 C8.225,37.275 6.65,32.9 6.65,28 C6.65,26.6 6.825,25.2 7,23.8 C7.175,23.975 7.525,24.15 7.875,24.5 C9.975,26.6 8.75,30.625 11.2,33.425 C12.775,35.35 12.25,39.025 11.025,40.95 Z M16.275,15.4 C15.225,16.275 11.9,16.975 9.45,17.15 C12.95,11.025 19.425,7 26.95,6.65 C26.6,7.7 26.25,9.625 25.9,10.85 C25.375,12.95 24.5,12.6 20.65,12.25 C16.975,12.075 18.025,14 16.275,15.4 Z M46.2,28.7 C44.275,28 41.3,27.3 40.425,28.35 C39.55,29.575 40.075,30.275 41.3,31.5 C44.1,34.3 41.3,36.4 39.9,38.15 C38.5,39.9 38.15,42.875 37.1,44.8 C36.225,46.375 33.25,47.775 31.675,47.425 C30.275,47.075 29.575,43.05 29.4,40.95 C29.05,38.85 27.65,39.2 25.375,38.85 C23.1,38.5 20.475,37.625 21.175,32.375 C21.35,29.925 22.4,29.05 23.45,28 C24.5,27.125 28.875,26.775 29.575,28.175 C30.1,29.575 32.375,29.575 34.825,29.05 C38.325,28.525 34.125,24.675 32.375,24.15 C31.15,23.8 32.375,25.9 30.625,25.9 C29.4,25.9 29.225,24.5 28,24.15 C26.775,23.8 22.75,26.425 22.225,24.85 C21.7,23.45 22.925,20.475 23.975,18.725 C25.2,16.975 26.425,19.425 27.65,19.425 C28.875,19.425 28.7,18.375 28.175,17.325 C27.65,15.925 29.575,15.05 30.8,14.175 C32.025,13.3 34.3,14.525 35.525,13.3 C36.4,12.425 36.225,9.45 36.225,7.875 C44.1,11.025 49.525,18.725 49.525,27.65 C49.525,28.525 49.525,29.225 49.35,30.1 C48.3,29.75 47.25,29.05 46.2,28.7 Z",
    id: "Shape",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icons/Small/Book-a-flight",
    transform: "translate(66.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.9,2.1 C21.15,1.35 19.2,2.1 17.625,3.675 C17.625,3.675 16.05,5.25 14.325,6.975 L3.075,4.425 L1.8,5.775 L10.65,10.725 C9.375,12 7.8,14.025 6.75,15.375 L2.25,14.85 L1.5,15.6 L6,18 L8.4,22.5 L9.15,21.75 L8.625,17.325 C9.975,16.275 11.925,14.7 13.275,13.425 L18.225,22.275 L19.575,20.925 L17.025,9.675 C18.75,7.95 20.325,6.375 20.325,6.375 C21.9,4.725 22.65,2.85 21.9,2.1 Z",
    id: "Path",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15,53 C15.4234481,58.8798862 17.9178502,64.0165244 22.4832062,68.4099147 C27.0485623,72.8033049 32.5541602,75 39,75 C43.5806593,75.012813 47.8783109,74.0484042 51.8929545,72.1067739 C55.9075982,70.1651435 64.251119,64.2810841 76.9235171,54.4545957",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 3
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlmWorld);
export default __webpack_public_path__ + "static/media/klm-world.78f149246c18ca6c3dddf85f93f4688a.svg";
export { ForwardRef as ReactComponent };